import { CartItemFragment } from '@graphcommerce/magento-cart-items'

export const fbqAddToCart = (addedItem: CartItemFragment, quantity: number, category: string) => {
  if (addedItem && addedItem.prices && addedItem.prices.row_total_including_tax.value) {
    // we need to manually calculate pricePerItemInclTax (https://github.com/magento/magento2/issues/33848)
    const pricePerItemInclTax = addedItem.prices.row_total_including_tax.value / addedItem.quantity
    const addToCartValue = pricePerItemInclTax * quantity

    if (typeof globalThis.fbq !== 'undefined') {
      globalThis.fbq('track', 'AddToCart', {
        content_name: addedItem?.product.name,
        content_category: category,
        content_ids: [addedItem.product.uid],
        content_type: 'product',
        value: addToCartValue,
        currency: addedItem?.prices?.price.currency,
      })
    }
  }
}
